import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppFilter } from "../../../models/app-filter.model";
import { AbEventoPsim } from "app/abstract/full-pages/timeline-eventos/evento-psim.abstract";

@Injectable({ providedIn: 'root' })
export class EventoPSIMService extends AbEventoPsim {

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public getEventosByPessoaLogada(filter: AppFilter) {
        return super.get(`evento_psim/pessoa_logada/${filter.encode()}`);
    }

    public getTimelineByPessoaLogadaV2(filter: AppFilter) {
        return super.get(`api/v1/timeline/pessoa-logada/${filter.encode()}`);
    }

    public getDetalhesEventosTimeline(idTimeline: number) {
        return super.get(`api/v1/evento-psim/detalhes-timeline/${idTimeline}`);
    }

    public getEventosHubByPessoaLogada(filter: AppFilter) {
        return super.get(`evento_psim/hub/pessoa_logada/${filter.encode()}`);
    }

    public isTimelineV2Ativo() {
        return super.get(`api/v1/timeline/enabled`).pipe(
            map((response: any) => !!response?.ativo)
        );
    }
}
